import { useEffect, useState } from "react";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints"; 
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const branchDeleteEndpoint = ApiEndpoints.branch.branchDelete;
const branchListEndpoint = ApiEndpoints.branch.branchList;
const branchEditPath = "edit-branch";
const tableHeader = ["Branch Name", "phone", "email", "address"];
const tbody = ["name", "contact", "email", "address"];

export default function BranchListing() {

  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", branchListEndpoint);
      const result = response.branch;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => { 
    dataFetch();
  }, []);

  const handleDelete = async (branch_id) => {
    const payload = { branch_id };
    try {
      const response = await ApiRequest("POST", branchDeleteEndpoint, payload);
      toast.success(response.message)
      dataFetch();
    } catch (error) {
      console.error(error);
    }
  };

  const pagename = {
    name: 'Branch Management',
    user: 'Admin',
    innerpage: 'Branch Management'
  }

  return (
    <>
    <AdminHeader pagename={pagename}/>

    <div className="add-btn-section">
      <Link className="admin-add-btn" to="/add-branch">Add +</Link>
      <DataTable
        data={data}
        tableHeader={tableHeader}
        tbody={tbody}
        editPath={branchEditPath}
        onDelete={handleDelete}
      />
    </div>
    </>
  )
}
